import { useFlag } from "../../../composables/useFlags/useFlag";

const { isFeatureAvailable } = useFlag("MSP_BRANDING");

export const mspSettingsRoutes = [
  {
    path: "settings",
    name: "mspSettings",
    component: () => import("@/modules/Settings/views/Msp"),
    redirect: {
      name: "msp-settings-administrators",
    },
    children: [
      {
        path: "administrators",
        name: "msp-settings-administrators",
        component: () =>
          import("@/modules/Settings/views/Msp/Administrators/index.vue"),
      },
      {
        path: "saml-sso",
        name: "msp-settings-saml-sso",
        component: () => import("@/modules/Settings/views/Msp/Saml/index.vue"),
      },
      ...(isFeatureAvailable.value
        ? [
            {
              path: "branding",
              name: "msp-settings-branding",
              component: () =>
                import("@/modules/Settings/views/Msp/Branding/index.vue"),
            },
          ]
        : []),
    ],
  },
];
